module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#user-square",
      toString: function () {
        return this.url;
      }
    }